import { Navigate } from "react-router-dom";
function ProtectedRoute({ userAuth, type, children }) {
  if (!userAuth) {
    if (type === "login") {
      return children;
    } else {
      return <Navigate to="/login" replace />;
    }
  } else if (userAuth && type === "login") {
    return <Navigate to="/" replace />;
  } else {
    return children;
  }
}

export default ProtectedRoute;
